import React, { createContext, useContext } from 'react';

// Create the Query Parameters Context
const ParamsContext = createContext();

// Custom hook to use the QueryParamsContext
export const useParams = () => {
  return useContext(ParamsContext);
};

// Export the context provider
export const ParamsProvider = ({ children, value }) => {
  return (
    <ParamsContext.Provider value={value}>
      {children}
    </ParamsContext.Provider>
  );
};